import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import API_BASE_URL from '../../ApiConfig/ApiConfig';
import Cookies from "js-cookie";
import profileIcon from "../../../Assets/profile 2.svg";
import close from "../../../../src/Assets/closeicon white.svg";
const Profile = ({ onClose }) => {
  const [userDetails, setUserDetails] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false); // Track edit mode
  const modalRef = useRef(null);
  const navigate = useNavigate();
  const token = Cookies.get('token');
  useEffect(() => {
    const fetchUserDetails = async () => {
      const token = Cookies.get('token');
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          const customerId = decodedToken.customerId;
          const email = decodedToken.email;
          console.log("this is email", email)

          const response = await fetch(`${API_BASE_URL}/api/users/customer/${customerId}`,
            { headers: { "Content-Type": "application/json" ,
              "Authorization": token ? `Bearer ${token}` : "",
            } });
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status} - ${response.statusText}`);
          }
          const data = await response.json();
          
          setUserDetails(data);

        } catch (error) {
          setError(`Error fetching user details: ${error.message}`);
        } finally {
          setLoading(false);
        }
      } else {
        setError('No token found in Cookies.');
        setLoading(false);

      }
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const handleLogout = () => {
    Cookies.remove('token');
    Cookies.remove('admin');
    navigate('/');
  };

  const messageBoxStyle = "bg-red-100 text-red-700 border border-red-400 rounded-lg p-2 mb-4";

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleEditToggle = () => {
    setIsEditMode(true); // Set the mode to edit
  };

  const handleSaveChanges = async () => {
    const token = Cookies.get('token');
    if (!token) return;

    const customerId = jwtDecode(token).customerId;

    // Log the customerId to check if it's correct
    console.log('Saving changes for customerId:', customerId);

    try {
      const response = await fetch(`${API_BASE_URL}/api/users/customer/${customerId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify({
          name: userDetails.name,
          email: userDetails.email,
          phone: userDetails.phone,
          address: userDetails.address,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to update profile: ${response.statusText}`);
      }

      const updatedData = await response.json();
      setUserDetails(updatedData);
      setIsEditMode(false); // Exit edit mode after saving
    } catch (error) {
      setError(`Error saving changes: ${error.message}`);
    }
  };

  return (
    <div className={`fixed inset-0 z-20 bg-black transition-opacity duration-500 ${isVisible ? 'bg-opacity-50' : 'bg-opacity-0'}`}>
      <div className="fixed top-10 right-10 z-30 transition-opacity duration-500 ease-in-out opacity-100">
        <div
          ref={modalRef}
          className={`bg-white rounded-lg shadow-lg w-[330px] transition-all duration-500 ease-in-out transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          style={{
            transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
            fontFamily: `'Inter', sans-serif`,
          }}
        >
          {/* Top Nav */}
          <div className="flex bg-[#DDE9FF] rounded-t-lg p-3 justify-between items-center">
            <p className="text-lg font-semibold text-black">{isEditMode ? "Edit Profile" : "Profile"}</p>
            <button onClick={onClose} className="text-gray-500 hover:text-black">
              <img
                src={close} // Replace with your image path
                alt="Close"
                className="h-7 w-7 object-contain"
              />
            </button>
          </div>

          <div className="p-4">
            {loading && <p className="text-center text-black">Loading...</p>}
            {error && (
              <div className="text-red-700 text-sm text-center mb-4">
                Error: {error}
              </div>
            )}

            {userDetails && !error && (
              <div className="text-black">
                <div className="flex items-center mb-4">
                  {/* Conditionally render the profile icon when not in edit mode */}
                  {!isEditMode && (
                    <img
                      src={profileIcon}
                      alt="Profile"
                      className="h-9 w-9 rounded-full border-2 border-white"
                    />
                  )}

                  <div className="ml-3 flex-1">
                    {/* Render this block only when not in edit mode */}
                    {!isEditMode && (
                      <p className="font-semibold text-[18px]">{userDetails.name}</p>
                    )}

                    {/* Render this block only when in edit mode */}
                    {isEditMode && null} {/* Hide input field */}
                  </div>

                  {/* Edit Profile Button */}

                </div>

                {/* Editable Fields for Email, Phone, and Address */}
                <div className="space-y-4">
                  {/* Conditionally render the Username input only when in Edit Mode */}
                  {isEditMode && (
                    <div className="flex items-center">
                      <label htmlFor="name" className="w-1/3 text-sm font-semibold">Username</label>
                      <input
                        type="text"
                        id="name"
                        value={userDetails.name}
                        onChange={(e) => setUserDetails({ ...userDetails, name: e.target.value })}
                        className="w-2/3 border p-2 rounded-md text-sm"
                      />
                    </div>
                  )}


                  <div className="flex items-center">
                    <label htmlFor="email" className="w-1/3 text-sm font-semibold">Email</label>
                    {isEditMode ? (
                      <input
                        type="email"
                        id="email"
                        value={userDetails.email}
                        onChange={(e) => setUserDetails({ ...userDetails, email: e.target.value })}
                        className="w-2/3 border p-2 rounded-md text-sm"
                      />
                    ) : (
                      <p className="w-2/3 text-sm">{userDetails.email}</p>
                    )}
                  </div>
                  <div className="flex items-center">
                    <label htmlFor="phone" className="w-1/3 text-sm font-semibold">Phone No.</label>
                    {isEditMode ? (
                      <input
                        type="text"
                        id="phone"
                        value={userDetails.phone}
                        onChange={(e) => setUserDetails({ ...userDetails, phone: e.target.value })}
                        className="w-2/3 border p-2 rounded-md text-sm"
                      />
                    ) : (
                      <p className="w-2/3 text-sm">{userDetails.phone}</p>
                    )}
                  </div>
                  <div className="flex items-center">
                    <label htmlFor="address" className="w-1/3 text-sm font-semibold">Address</label>
                    {isEditMode ? (
                      <input
                        type="text"
                        id="address"
                        value={userDetails.address}
                        onChange={(e) => setUserDetails({ ...userDetails, address: e.target.value })}
                        className="w-2/3 border p-2 rounded-md text-sm"
                      />
                    ) : (
                      <p className="w-2/3 text-sm">{userDetails.address}</p>
                    )}
                  </div>
                </div>

                {/* Save Button visible only in edit mode */}
                {isEditMode && (
                  <div className="flex justify-end mt-6">
                    <button onClick={handleSaveChanges} className="bg-[#3159A6] text-white px-6 py-1.5 rounded-[4px] shadow font-medium">
                      Save changes
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Hide Logout Button when in Edit Mode */}
            {!isEditMode && (
              <div className="flex justify-between items-center mt-6">
                <button
                  onClick={handleEditToggle}
                  className="text-[#292D32] border-2 border-[#00000033] hover:bg-gray-100 font-semibold text-sm px-3 py-1 rounded-md"
                >
                  Edit Profile
                </button>
                <button
                  onClick={handleLogout}
                  className="bg-[#3159A6] text-white px-10 py-1 rounded-[4px] shadow font-medium"
                >
                  Logout
                </button>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
